import axios from 'src/utils/axios';

type DVOpts = { actingOnMemberId?: number | null };

export interface QITAnswer {
  qitId: number;
  label: string;
  questionType: string;
  displayValue: string;
  lastUpdatedAt: string | null;
  isStale: boolean;
  numberOfFilesRequired: number;
  files: Array<{ id: number; name: string }>;
  answeredAt: string | null;
}

export const getSectionAnswers = (
  sectionId: string,
  opts: DVOpts = {}
): Promise<QITAnswer[]> => {
  const url = opts.actingOnMemberId
    ? `data-vault/members/${opts.actingOnMemberId}/profile-survey/sections/${sectionId}/answers/`
    : `profile-survey/sections/${sectionId}/answers/`;
  return axios.get<{ answers: QITAnswer[] }>(url).then((r) => r.data.answers);
};
